import CityPageTemplate from "../city-template/CityPageTemplate";
import { independenceConfig } from "./data";

export default function IndependencePage() {
  return <CityPageTemplate config={independenceConfig} />;
}